module.exports = __webpack_public_path__ + "static/media/step1-chs.77c933dc.png";